import axios from "axios";
import { stringify } from "qs";

const { BACKEND_URL } = process.env;

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
const Api = axios.create({
  baseURL: `${BACKEND_URL}/api/joinWebLink`,
  timeout: 0,
  withCredentials: true,
  mode: "no-cors",
  crossDomain: true,
  credentials: "same-origin",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Allow-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true,
    "Access-Control-Allow-Headers": "x-requested-with",
  },
});

const projectItemSharingLinkData = async (referenceId) => {
  return Api.get(`/${referenceId}`);
};

const projectItemsPaginate = async (data) => {
  return Api.get(`/paginateItems?${stringify(data)}`);
};

const projectItemsDownload = async (data) => {
  return Api.get(`/download/items?${stringify(data)}`, {
    responseType: "blob",
  });
};

const getDownloadLinkByItemId = (itemId, params = {}) => {
  return Api.get(`/view/item/${itemId}?${stringify(params)}`);
};

const Http = {
  projectItemSharingLinkData,
  projectItemsPaginate,
  projectItemsDownload,
  getDownloadLinkByItemId,
};

export default Http;
